import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, FileText, Sofa, Palette, Layers, Rows3, Ruler,
  Settings as SettingsIcon, Newspaper, Images, MessageSquare, Star,
  Calculator, DollarSign, LogOut, Menu, X, HomeIcon
} from "lucide-react";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";
import { toast } from "sonner";

const NAV = [
  { to: "/admin", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/quotes", label: "Teklifler", icon: FileText },
  { to: "/admin/messages", label: "Mesajlar", icon: MessageSquare },
  { to: "/admin/pricing", label: "Fiyatlandırma", icon: DollarSign },
  { to: "/admin/furniture-types", label: "Mobilya Türleri", icon: Sofa },
  { to: "/admin/colors", label: "Renkler", icon: Palette },
  { to: "/admin/covers", label: "Kapak Türleri", icon: Layers },
  { to: "/admin/legs", label: "Ayak Türleri", icon: Rows3 },
  { to: "/admin/handles", label: "Kulp Türleri", icon: Ruler },
  { to: "/admin/projects", label: "Çalışmalar", icon: Images },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/testimonials", label: "Yorumlar", icon: Star },
  { to: "/admin/home", label: "Ana Sayfa İçeriği", icon: HomeIcon },
  { to: "/admin/settings", label: "Site Ayarları", icon: SettingsIcon },
];

export default function AdminLayout() {
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const [me, setMe] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/me")
      .then((r) => { if (!cancelled) setMe(r.data); })
      .catch(() => { if (!cancelled) nav("/admin/login"); });
    return () => { cancelled = true; };
  }, [nav]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) { /* ignore */ }
    toast.success("Çıkış yapıldı");
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-ink-50" data-testid="admin-layout">
      {/* Mobile top bar */}
      <div className="lg:hidden sticky top-0 z-30 flex items-center justify-between bg-white border-b border-ink-100 h-16 px-4">
        <Logo />
        <button onClick={() => setOpen(true)} className="h-10 w-10 grid place-items-center rounded-full bg-brand-50 text-brand-700"><Menu className="h-5 w-5" /></button>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <aside className={`${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 fixed lg:sticky lg:top-0 z-40 top-0 left-0 h-screen w-72 bg-white border-r border-ink-100 flex flex-col transition-transform`}>
          <div className="p-5 flex items-center justify-between border-b border-ink-100">
            <Logo />
            <button className="lg:hidden" onClick={() => setOpen(false)}><X className="h-5 w-5" /></button>
          </div>
          <nav className="p-3 flex-1 overflow-y-auto admin-scroll">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                onClick={() => setOpen(false)}
                data-testid={`admin-nav-${n.to.split("/").pop()}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold mb-0.5 transition-colors ${isActive ? "gradient-primary text-white" : "text-ink-700 hover:bg-brand-50"}`
                }
              >
                <n.icon className="h-4 w-4" />
                {n.label}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-ink-100">
            <div className="text-xs text-ink-500 mb-2">Giriş: <b>{me?.username || "..."}</b></div>
            <button data-testid="admin-logout" onClick={logout} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-ink-900 text-white px-4 py-2 text-xs font-bold uppercase tracking-widest hover:bg-brand-600 transition-colors">
              <LogOut className="h-4 w-4" /> Çıkış
            </button>
          </div>
        </aside>

        {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}

        <main className="flex-1 min-w-0 p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
